import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsJiraLinkIssueBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Unlink a Jira issue from a post</div>
          <div className="text">
            Unlinks a Jira issue from a Canny post. Requires the Jira integration to be installed
            and configured.
          </div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The ID of the post to unlink.',
                heading: 'postID',
                subheading: 'string',
              },
              {
                description: 'The key of the Jira issue to unlink.',
                heading: 'issueKey',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns "success" if the post was unlinked successfully.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/posts/unlink_jira</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/posts/unlink_jira"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d postID=5f3c3ed4b1cacd1501ba1234 \\
    -d issueKey=PROJ-123`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">success</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
